/**
 * The steps of an automation in plain language, as the nodes of its path: how it starts, what Pieve does
 * (a schedule or trigger follows written instructions; a workflow runs named steps in order), and where
 * each run's outcome goes.
 */
const buildAutomationPathNodes = ({ kind, schedule = null, trigger = null, workflow = null }) => {
  if (kind === 'schedules' && schedule) {
    return [
      { id: 'start', role: 'start', title: schedule.cadenceSummary, body: schedule.timeZone ? `Times are in ${schedule.timeZone}.` : null },
      { id: 'work', role: 'step', title: schedule.promptSummary || 'Pieve follows your instructions', instructions: schedule.prompt },
      { id: 'end', role: 'end', title: 'Each run is saved in run history with what Pieve did and the result.' }
    ];
  }

  if (kind === 'triggers' && trigger) {
    return [
      { id: 'start', role: 'start', title: trigger.triggerSummary, body: trigger.pollIntervalMinutes ? `Pieve checks every ${trigger.pollIntervalMinutes} minutes.` : null },
      { id: 'work', role: 'step', title: trigger.promptSummary || 'Pieve follows your instructions', instructions: trigger.prompt },
      { id: 'end', role: 'end', title: 'Each run is saved in run history with what Pieve did and the result.' }
    ];
  }

  if (kind === 'workflows' && workflow) {
    const steps = Array.isArray(workflow.definition?.steps) ? workflow.definition.steps : [];

    return [...steps.map((step, index) => ({ id: step.id || `step-${index}`, role: index === 0 ? 'start' : 'step', title: step.name || step.title || `Step ${index + 1}`, body: step.description || null })), { id: 'end', role: 'end', title: 'Each run is saved in run history, step by step.' }];
  }

  return [];
};

export default buildAutomationPathNodes;
